/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Assistant_Not_AllowedInputs */

const en_error_assistant_not_allowed = /** @type {(inputs: Error_Assistant_Not_AllowedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your roles do not let you ask the assistant. Ask an administrator.`)
};

/**
* | output |
* | --- |
* | "Your roles do not let you ask the assistant. Ask an administrator." |
*
* @param {Error_Assistant_Not_AllowedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_assistant_not_allowed = /** @type {((inputs?: Error_Assistant_Not_AllowedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Assistant_Not_AllowedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_assistant_not_allowed(inputs)
});